// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore id-components does not have type declarations. Replace this component with id-components v2 when ready.
import { AdditionalInfo } from '@bbc-account/id-components';
import styled from 'styled-components';

export const StyledIframePasswordForm = styled.div`
    display: flex;
    gap: var(--spacing-4);
    flex-direction: column;
`;

export const StyledIframePasswordAdditionalInfo = styled(AdditionalInfo)`
    flex-flow: column;
    gap: var(--spacing-4);

    @media (min-width: 25rem) {
        flex-flow: row;
    }
`;
